import { render, staticRenderFns } from "./RegisterStep3.vue?vue&type=template&id=5ac0ea2c&scoped=true"
import script from "./RegisterStep3.vue?vue&type=script&lang=js"
export * from "./RegisterStep3.vue?vue&type=script&lang=js"
import style0 from "./RegisterStep3.vue?vue&type=style&index=0&id=5ac0ea2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac0ea2c",
  null
  
)

export default component.exports